import * as React from 'react';
import {Popover, WithStyles, withStyles,} from '@material-ui/core';
import TranslateNew from '@translate/TranslateNew';
import { EditActionStyle } from '../EditAction.style';
import VVFullDatePicker from '@components/common/timepicker/VVFullDatePicker';
import { IDateRange } from '@containers/calendar/calendar.helpter';
import { styleColors } from 'src/main.style';

const tn: TranslateNew = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof EditActionStyle> {
  offset:number;
  selectedDays:IDateRange[];
  selectRange:(from:number,to:number, days:boolean[]) => void;
}

interface IState {
  edit:"STARTDATE"|"ENDDATE"|null;
  editAnchorEl:HTMLDivElement|null;
  startDate:Date;
  endDate:Date;
}

class WizardSelectDays extends React.Component<IProps, IState> {

  private endDateRef:React.RefObject<HTMLDivElement> = React.createRef();
  private startDateRef:React.RefObject<HTMLDivElement> = React.createRef();

  constructor(props: IProps) {
    super(props);

    let startDate = new Date();
    let endDate = new Date();
    if (props.selectedDays.length > 0) {
      startDate = new Date(this.props.selectedDays[0].start)
      endDate = new Date(this.props.selectedDays[0].end)
    }

    this.state = {
      startDate,
      endDate,
      edit:null,
      editAnchorEl:null
    };
  }

  public componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any): void {
    if (prevProps.selectedDays !== this.props.selectedDays && this.props.selectedDays.length > 0) {
      this.setState({startDate:new Date(this.props.selectedDays[0].start), endDate:new Date(this.props.selectedDays[0].end)})
    }
    if (prevState.edit !== null && this.state.edit === null) {
      this.props.selectRange(this.state.startDate.getTime(), this.state.endDate.getTime(), [true,true,true,true,true,true,true])
    }
  }

  public render() {
    const {classes, offset} = this.props;

    const badEnd:boolean =  (this.state.endDate.getTime() < this.state.startDate.getTime());
    const fewDays:boolean =  ((this.state.endDate.getTime() -this.state.startDate.getTime())/(60*60*24*1000) < 10) ;
    
    return (
      <div className={classes.pane+" "+classes.paneStep} style={{ left: (offset*100)+"%", opacity:offset===0?1:0, 
        gap: '16px', paddingTop: '16px'}}>
        <div style={{ display: 'flex',alignItems: 'center', alignSelf: 'center'}}>
          {tn.lang.calWizardStart}
        </div>
        <div onClick={() => this.setState({edit:"STARTDATE", editAnchorEl:this.startDateRef.current})} ref={this.startDateRef}
          style={{fontSize: '26px', fontWeight: 600, padding: '8px',display: 'flex',alignItems: 'center', alignSelf: 'center',
            backgroundColor: styleColors.greyLight2, border: `1px solid ${styleColors.greyMedium1}`, borderRadius: '4px'}}>
          {tn.formatDateYearMonthDay(this.state.startDate)}
        </div>
        <div style={{ display: 'flex',alignItems: 'center', alignSelf: 'center'}}>
          {tn.lang.calWizardEnd}
        </div>
        <div onClick={() => this.setState({edit:"ENDDATE", editAnchorEl:this.endDateRef.current})} ref={this.endDateRef}
          style={{fontSize: '26px', fontWeight: 600, padding: '8px',display: 'flex',alignItems: 'center', alignSelf: 'center',
            backgroundColor: styleColors.greyLight2, border: `1px solid ${styleColors.greyMedium1}`, 
            borderRadius: '4px', color:(badEnd?styleColors.pureRed:styleColors.greyDark2)
          }}>
          {tn.formatDateYearMonthDay(this.state.endDate)}
        </div>
        {fewDays && <div style={{ display: 'flex',alignItems: 'center', alignSelf: 'center'}}>
          {tn.lang.calWizardError}
        </div>}
        <Popover 
          anchorEl={this.state.editAnchorEl}
          onClose={() => this.setState({edit:null})}
          open={(this.state.edit === "ENDDATE" || this.state.edit === "STARTDATE")}
          disableScrollLock={true}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <VVFullDatePicker open={true} date={this.state.edit === "STARTDATE"?this.state.startDate:this.state.endDate} 
            setDate={(date) => {
              if (this.state.edit === "STARTDATE") 
                {this.setState({startDate:date});} 
              else 
                {this.setState({endDate:date});}}}/>
        </Popover>
      </div>
    );
  }


}

export default withStyles(EditActionStyle)(WizardSelectDays);



// WEBPACK FOOTER //
// ./src/components/calendar2/editPane/editActions/Wizard/WizardSelectDays.tsx